import { ActionItem } from "../../../types/button/ActionButton";

export const getPayableTableActions = ({
  row,
  handlers,
}: {
  row: any;
  handlers: {
    onView: (id: number) => void;
    onPay: (id: number) => void;
    onHistory: (id: number) => void;
  };
}): ActionItem[] => {

  const actions: ActionItem[] = [];

  // 👁️ Ver detalle
  actions.push({
    key: "view",
    label: "Ver Detalle",
    onClick: () => handlers.onView(row.id),
  });

  // 💰 Pagar (solo si no está pagado)
  if (row.status !== "PAID") {
    actions.push({
      key: "pay",
      label: "Registrar Pago",
      onClick: () => handlers.onPay(row.id),
    });
  }

  // 📜 Historial
  actions.push({
    key: "history",
    label: "Ver Historial",
    onClick: () => handlers.onHistory(row.id),
  });

  return actions;
};